import './CloseCard.scss';

const CloseCardBody = () => {
	return (
		<div className='CloseCard'>
			<p>Description</p>
				<h3>Subtitle</h3>
				<p>Description</p>
				<p>Description</p>
				<p>Description</p>
				<p>Description</p>
				<p>Description</p>
				<p>Description</p>
				<p>Description</p>
				<p>Description</p>
				<p>Description</p>
				<p>Description</p>
				<p>Description</p>
				<p>Description</p>
				<p>Description</p>
				<p>Description</p>
				<p>Description</p>
				<p>Description</p>
				<p>Description</p>
				<p>Description</p>
				<p>Description</p>
				<p>Description</p>
				<p>Description</p>
		</div>
	);
};

export default CloseCardBody;
